import interceptors from "./interceptors/index";

const brand = process.env.REACT_APP_BRAND || "S10";

export const getSearch = (descrip = "") => {
  return interceptors({
    url: "/online-promocional/article",
    method: "GET",
    params: { p_formato: brand, p_descripcion: descrip.toUpperCase() },
  });
};
